module.exports = __webpack_public_path__ + "img/brownIncident.55eb04b8.svg";